export const FETCH_NOTIFICATIONS = "FETCH_NOTIFICATIONS";
export const TOTAL_NOT_READ_NOTIFICATIONS = "TOTAL_NOT_READ_NOTIFICATIONS";
